<template>
<div class="chapter">
<div class="inner_page">
<div id="epub4231-2.html" xml:lang="en-US">
<div class="Basic-Text-Frame">
<p class="CN para-style-override-1" id="toc_marker-3" xml:lang="en-GB"><span class="char-style-override-1">Also by Mark Billingham</span></p>
<p class="AdCardsubhead">The DI Tom Thorne series</p>
<p class="AdCardTitles">Sleepyhead</p>
<p class="AdCardTitles">Scaredy Cat</p>
<p class="AdCardTitles">Lazybones</p>
<p class="AdCardTitles">The Burning Girl</p>
<p class="AdCardTitles">Lifeless</p>
<p class="AdCardTitles">Buried</p>
<p class="AdCardTitles">Death Message</p>
<p class="AdCardTitles">Bloodline</p>
<p class="AdCardTitles">From the Dead</p>
<p class="AdCardTitles">Good as Dead</p>
<p class="AdCardsubhead">Other fiction</p>
<p class="AdCardTitles">In the Dark</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epub4231-2.vue?55bf6158